/* eslint-disable no-param-reassign, no-unused-vars */
import getDefaultState from './initialState'

export default {
  RESET_STORE_OFFER(state) {
    Object.assign(state, getDefaultState())
  },
  SET_ACTIVE_TARIFF(state, payload) {
    const legalTariffs = [
      'p-private',
      'p-move',
      'p-combi',
      'b-business',
      'b-move',
      'small-business',
    ]
    state.activeTariff = legalTariffs.includes(payload)
      ? payload
      : legalTariffs[0]
  },
  SET_STEP(state, payload) {
    if (payload > 0 && payload < 6) {
      state.step = payload
    }
  },
  SET_PREMIA(state, payload) {
    state.premia.insurable = payload.insurable
    state.premia.components = payload.components
    state.premia.totalPremium = {
      value: payload.totalPremium.value,
      currency: payload.totalPremium.currency,
    }
  },
  SET_PRIVATE_BASIC_QUESTIONS(state, payload) {
    Object.assign(state.privateBasicQuestions, payload)
  },
  SET_BUSINESS_BASIC_QUESTIONS(state, payload) {
    Object.assign(state.businessBasicQuestions, payload)
  },
  SET_BUSINESS_MOVE_BASIC_QUESTIONS(state, payload) {
    Object.assign(state.businessMoveBasicQuestions, payload)
  },
  SET_POLICY_HOLDER_DATA(state, payload) {
    Object.assign(state.policyHolderData, payload)
  },
  SET_BUSINESS_POLICY_HOLDER_DATA(state, payload) {
    Object.assign(state.businessPolicyHolderData, payload)
  },
  SET_ASSESSMENT_QUESTIONS(state, payload) {
    Object.assign(state.assessmentQuestions, payload)
  },
}
